<template>
	<div>
		<b-container class="py-5 py-xl-5 container-project">
			<h5 class="bolder show-apartment-title" v-if="apartments.length > 1">Te invitamos a seleccionar una de tus propiedades aquí, para poder ver pagos, documentos y detalles.</h5>
			<h5 class="bolder show-apartment-title" v-else>Ve los pagos, documentos y detalles de tu propiedad aquí</h5>
		</b-container>
		<b-row no-gutters>
			<b-col cols="12" class="mb-5">
				<b-card>
					<apartments :asset="selectedApartment" :tab_index="tab_index" @selectedApartment="selectedApartmentData" />
				</b-card>
			</b-col>
		</b-row>
	</div>
</template>
<script>
	import apartments from "../views/apartments/Apartments";
	export default {
		name: "index",
		components: {
			apartments
		},
		data() {
			return {
				asset_id: null,
				apartments: [],
				tab_index: 0,
				selectedApartment: null
			}
		},
		mounted() {
			this.setApartments();
		},
		methods: {
			setApartments(){
				this.axios.get("assets/").then(result => {
					if(typeof result.data.length != undefined){
						this.apartments = result.data.assets
						this.$store.commit('setApartments', result.data.assets);
						this.selectedApartment = this.apartments[0];
					}
				}).catch(error => {
					console.log(error)
				});
			},
			selectedApartmentData(value){
				this.selectedApartment = value;
			}
		},
		computed: {
			project() {
				return (this.selectedApartment ? this.$store.getters.getProjectByMoby(this.selectedApartment.project_id) : null );
			}
		}
	};
</script>
<style>
@media (min-width:992px) {
	.logo-footer-size{
		width:100%;
		height:100%;
	}
	.logo-footer-size-project{
		width: 100%;
		height: 100%;
	}
}
@media (max-width:992px){
	.logo-footer-size{
		width:50%;
		height:50%;
	}
	.logo-footer-size-project{
		width: 70%;
		height: 70%;
	}
}
</style>